module.exports = __webpack_public_path__ + "img/aunt.be5030ca.webp";